import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fcf523dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "card border mb-10" }
const _hoisted_3 = { class: "card-body p-10" }
const _hoisted_4 = { class: "row align-items-center desktop" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "image-container-grande" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "overlay" }
const _hoisted_9 = { class: "vertical-text-grande" }
const _hoisted_10 = { class: "mt-5 fs-1 fw-bold" }
const _hoisted_11 = {
  key: 0,
  class: "my-3"
}
const _hoisted_12 = {
  key: 0,
  class: "badge badge-primary me-5 mt-2"
}
const _hoisted_13 = {
  key: 1,
  class: "badge badge-success me-5 mt-2"
}
const _hoisted_14 = {
  key: 2,
  class: "badge badge-particulares me-5 mt-2"
}
const _hoisted_15 = {
  key: 3,
  class: "badge badge-profesionales me-5 mt-2"
}
const _hoisted_16 = {
  key: 4,
  class: "badge badge-empresas me-5 mt-2"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "mt-5 fs-3 fw-bold" }
const _hoisted_19 = { class: "row mt-5 ms-0 align-items-center" }
const _hoisted_20 = { class: "col-md-2 col-sm-4 card border border-dark border-dashed text-center p-2 me-3 mb-2" }
const _hoisted_21 = { class: "text-muted fw-bold" }
const _hoisted_22 = { class: "fw-bold fs-3" }
const _hoisted_23 = { class: "col-md-2 col-sm-4 card border border-dark border-dashed text-center p-2 me-3 mb-2" }
const _hoisted_24 = { class: "text-muted fw-bold" }
const _hoisted_25 = { class: "fw-bold fs-3" }
const _hoisted_26 = { class: "col-md-3 col-sm-4 card border border-dark border-dashed text-center p-2 me-3 mb-2" }
const _hoisted_27 = { class: "text-muted fw-bold" }
const _hoisted_28 = { class: "fw-bold fs-3" }
const _hoisted_29 = { class: "col-md-12 col-sm-4 card p-2 me-3 mb-2" }
const _hoisted_30 = { class: "fw-bold mt-3 fs-3" }
const _hoisted_31 = { class: "text-muted" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { key: 3 }
const _hoisted_36 = { class: "mt-3" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 0,
  class: "card border mb-10"
}
const _hoisted_39 = { class: "card-body p-10" }
const _hoisted_40 = { class: "row align-items-center desktop" }
const _hoisted_41 = { class: "fs-1 fw-bold" }
const _hoisted_42 = { class: "mt-2 mb-10 fs-4" }
const _hoisted_43 = { class: "row mb-6" }
const _hoisted_44 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_45 = { class: "col-lg-8 fv-row" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "row mb-6" }
const _hoisted_51 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_52 = { class: "col-lg-8 fv-row" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label" }, null, -1))
const _hoisted_59 = { class: "col-lg-8 fv-row form-check form-check-custom form-check-solid" }
const _hoisted_60 = { class: "form-check-label" }
const _hoisted_61 = {
  type: "button",
  class: "btn btn-active-light-primary botonPrivacidad",
  "data-bs-toggle": "modal",
  "data-bs-target": "#condiciones-privacidad"
}
const _hoisted_62 = { class: "row mb-6" }
const _hoisted_63 = { class: "col-lg-8 offset-lg-4" }
const _hoisted_64 = { class: "my-6 row justify-content-center" }
const _hoisted_65 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CondicionesPrivacidadModal = _resolveComponent("CondicionesPrivacidadModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.datosCurso)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                      src: _ctx.datosCurso.imagen,
                      alt: _ctx.datosCurso.nombre,
                      class: "background-image rounded mx-auto d-block imagen-curso"
                    }, null, 8, _hoisted_7),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.datosCurso.areaTematica), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.datosCurso.nombre), 1),
                (_ctx.datosCurso.presencial || _ctx.datosCurso.videoconferencia)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_ctx.datosCurso.presencial)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t("cursoPresencial")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.datosCurso.videoconferencia)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t("cursoVideoconferencia")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.datosCurso.badges.includes('PARTICULAR'))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("etiquetaParticulares")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.datosCurso.badges.includes('PROFESIONAL'))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t("etiquetaProfesionales")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.datosCurso.badges.includes('EMPRESA'))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t("etiquetaEmpresas")), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "mt-2 fs-4",
                  innerHTML: _ctx.datosCurso.descripcion ?? _ctx.datosCurso.descripcionCorta
                }, null, 8, _hoisted_17),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("informacionImportante")), 1),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("cursoFechaInicio")), 1),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(new Date(_ctx.datosCurso.inicio)
                    .toLocaleDateString("es-ES", {
                      day: "2-digit",
                      month: "long",
                    })
                    .replace(/\s[0-9]{4}$/, "")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("cursoFechaFin")), 1),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(new Date(_ctx.datosCurso.fin)
                    .toLocaleDateString("es-ES", {
                      day: "2-digit",
                      month: "long",
                    })
                    .replace(/\s[0-9]{4}$/, "")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("cursoHorario")), 1),
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.datosCurso.horario), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("inscripciones")) + ": ", 1),
                      (new Date() < new Date(_ctx.datosCurso.inicioInscripciones))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t("fechaAPartirDe", {
                      inicioInscripciones: new Date(
                        _ctx.datosCurso.inicioInscripciones
                      )
                        .toLocaleDateString("es-ES", {
                          day: "2-digit",
                          month: "long",
                        })
                        .replace(/\s[0-9]{4}$/, ""),
                    })), 1))
                        : (
                    new Date() > new Date(_ctx.datosCurso.fin) ||
                    new Date() > new Date(_ctx.datosCurso.finInscripciones)
                  )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t("inscripcionesCerradas")), 1))
                          : (
                    _ctx.datosCurso.inscripcionesActivas >= _ctx.datosCurso.plazas
                  )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.$t("plazasCompletas")), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t("percentPlazasOcupadas", {
                    plazasOcupadas: (
                      (_ctx.datosCurso.inscripcionesActivas / _ctx.datosCurso.plazas) *
                      100
                    ).toFixed(0),
                  })), 1))
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      (
                    new Date() >= new Date(_ctx.datosCurso.inicioInscripciones) &&
                    _ctx.datosCurso.inscripcionesActivas < _ctx.datosCurso.plazas
                  )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                            _createVNode(_component_el_progress, {
                              percentage: 
                      (_ctx.datosCurso.inscripcionesActivas / _ctx.datosCurso.plazas) *
                      100
                    ,
                              "stroke-width": 12,
                              "show-text": false
                            }, null, 8, ["percentage"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          (
        new Date() > new Date(_ctx.datosCurso.inicioInscripciones) &&
        new Date() < new Date(_ctx.datosCurso.finInscripciones)
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("bajaInscripcion")), 1),
                    _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t("introBajaInscripcion")), 1),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.dni.label")), 1),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "dni",
                              placeholder: " ",
                              modelValue: _ctx.dni,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dni) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("div", _hoisted_49, [
                                _createVNode(_component_ErrorMessage, { name: "dni" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.email.label")), 1),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "email",
                              placeholder: " ",
                              modelValue: _ctx.email,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("div", _hoisted_56, [
                                _createVNode(_component_ErrorMessage, { name: "email" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createElementVNode("div", _hoisted_59, [
                        _withDirectives(_createElementVNode("input", {
                          name: "politicaPrivacidad",
                          class: "form-check-input form-control form-control-solid",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.politicaPrivacidad) = $event)),
                          id: "politicaPrivacidad"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.politicaPrivacidad]
                        ]),
                        _createElementVNode("label", _hoisted_60, [
                          _createTextVNode(_toDisplayString(_ctx.$t("aceptacion")) + " ", 1),
                          _createElementVNode("button", _hoisted_61, _toDisplayString(_ctx.$t("PoliticaPrivacidad")), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createVNode(_component_ErrorMessage, {
                          name: "politicaPrivacidad",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _ctx.guardar,
                          loading: _ctx.bajaInscripcion
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("bajaInscripcionGuardar")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "loading"])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_CondicionesPrivacidadModal, { id: "condiciones-privacidad" })
  ], 64))
}